import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import moment from "moment";

import { makeStyles } from "@mui/styles";
import logo from "../../assets/images/logo.png";
import { LocationCity } from "@mui/icons-material";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { IconButton } from "@mui/material";
import {
  addCommasToNumber,
  debounce,
  featuredJobs,
  formatEducationRequired,
  jobs,
  show_des_data,
  show_proper_words,
} from "../../utils/Constant";
import WorkIcon from "@mui/icons-material/Work"; // Import job-related icon
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import PostJobModal from "../../components/popUp/PostJobPopUp";
import PostJobDetail from "../../components/popUp/PostJobDetail";
import {
  _get_job_feed_list_blog_api,
  delete_live_job_feed_api,
  favourite_live_job_api,
  get_outside_jobs_api,
  job_reniew_api,
} from "../../DAL/TalentSourceAPI/TalentSourceApi";
import { useSnackbar } from "notistack";
import { useIds } from "../../hook/AdminContext";
import PageLoading from "../../components/loader/PageLoading";
import CustomPopoverSection from "../../components/menu/MebuCustomPopOverSection";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import UpgradeModal from "../../components/popUp/UpgradeModal";

import CustomConfirmation from "../../components/popUp/CustomConfirmation";
import { s3baseUri } from "../../config/config";
import JobSkeleton from "../../components/loader/HJobsSkeletin";
import RecordNoImage from "../../components/recordNotFound/RecordNoImage";
import { scroller } from "react-scroll";
import JobPostDescription from "../liveJobFeed/components/JobPostDescription";
import { get_jobs_list } from "../../DAL/jobs/jobs";
import PostJobHeader from "./PostJobHeader";
import JobListCard from "../../components/jobs/JobListCard";
import Footer from "../Footer/Footer";
import CustomPopoverNew from "../../components/CustomPopoverNew";
import SharePostPopup from "../../components/cards/SharePostPopup";
import CustomModalLayout from "../../components/modal/CustomModalLayout";

const useStyles = makeStyles(() => ({
  loading: {
    margin: "auto",
  },
}));

export default function JobPostList({ loading, setLoading }) {
  const [data, setData] = useState([]);
  const location = useLocation();

  const {
    findId,
    setBreadCrumb,
    userInfo,
    isRefresh,
    adminSetting,
    handleReportPost,
  } = useIds();

  const params = useParams();
  const sourceSlug = params?.source_slug || "";

  const pageTitle = sourceSlug ? sourceSlug : "Latest Jobs";

  const navigate = useNavigate();
  const [selectedJob, setSelectedJob] = useState(null);
  const [openRenewConfirm, setOpenRenewConfirm] = useState(false);
  const [renewJobId, setRenewJobId] = useState(null);

  const { activeSourceList, setUpdateJobOnNotification } = useIds();
  const { enqueueSnackbar } = useSnackbar();
  const [loadMorePath, setLoadMorePath] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deletingMemberId, setDeletingMemberId] = useState("");
  const scrollRef = useRef(null); // Reference to the scrollable container
  const [isHovered, setIsHovered] = useState(false);

  const observer = useRef();
  const [categories, setCategories] = useState([]);
  const [isScrolling, setIsScrolling] = useState(false);

  // const [loading, setLoading] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoadMoreAvailable, setIsLoadMoreAvailable] = useState(true);
  const [pageNumber, setPageNumber] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const [selectedFilter, setSelectedFilter] = useState(
    activeSourceList?.[0]?._id || ""
  );

  const load_more_path = "api/jobs/list?page=0&limit=50";

  const [cv, setCv] = useState(null);
  const [sourceId, setsourceId] = useState(null);
  const [bookmarkedJobs, setBookmarkedJobs] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [partnersObj, setPartnersObj] = useState({});
  const [editMode, setEditMode] = useState(false);

  const classes = useStyles();
  const pathname = location.pathname;

  const [open, setOpen] = useState(false);
  const [openUpgradeModal, setOpenUpgradeModal] = useState(false);

  // share job State
  const [openSharePost, setOpenSharePost] = useState(null);

  const isMobile = useMediaQuery("(max-width:600px)", { noSsr: true });
  const isTablet = useMediaQuery("(max-width:768px)", { noSsr: true });
  const isSmallMobile = useMediaQuery("(max-width:600px)", { noSsr: true });
  const handleNavigateAppliedJobs = () => {
    if (sourceSlug) {
      navigate(`/${sourceSlug}/applied-jobs`, {
        state: { routePath: "home" },
      });
    } else {
      navigate(`/applied-jobs`, {
        state: { routePath: "home" },
      });
    }
  };
  const fetchCategories = async (
    path,
    search,
    isLoadMore = false,
    page = 0
  ) => {
    if (!isLoadMore) {
      setLoading(true);
      path = load_more_path;
    }

    const response = await get_jobs_list(page, 7, "", sourceSlug);

    if (response.code === 200) {
      setLoadMorePath(response.load_more_url || ""); // in case your API gives a next page URL
      setTotalPages(response.total_pages || 0);
      setsourceId(response.created_for);

      setIsLoadMoreAvailable(response.jobs.length > 0);

      if (isLoadMore) {
        setCategories((prev) => [...prev, ...response.jobs]);
        setPageNumber(page); // ✅ update current page
      } else {
        setCategories(response.jobs);
        setPageNumber(0); // reset to first page
      }

      setPartnersObj(response.jobs); // optional
      setLoading(false);
      setIsLoadingMore(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
      setIsLoadingMore(false);
    }
  };

  const handleRenewJob = async (id) => {
    const response = await job_reniew_api(id);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      setCategories((prev) =>
        prev.map((obj) =>
          obj._id === id
            ? {
                ...obj,
                renewalStatus: {
                  ...obj.renewalStatus,
                  canRenew: false,
                },
              }
            : obj
        )
      );
      fetchCategories(load_more_path, searchTerm, false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
    setOpenRenewConfirm(false);
  };
  const handleRenewClick = (id) => {
    setRenewJobId(id);
    setOpenRenewConfirm(true);
  };

  const loadMoreData = () => {
    if (!isLoadMoreAvailable || isLoadingMore) return;

    const nextPage = pageNumber + 1;
    setIsLoadingMore(true);
    fetchCategories(loadMorePath, searchTerm, true, nextPage);
  };

  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && totalPages > pageNumber) {
            loadMoreData();
          }
        },
        {
          threshold: 1.0, // Fully visible
        }
      );

      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totalPages, pageNumber]
  );

  useEffect(() => {
    setLoading(true);
    if (searchTerm !== "") {
      const timeoutId = setTimeout(() => {
        fetchCategories(loadMorePath, searchTerm, false);
      }, 800);
      return () => clearTimeout(timeoutId);
    } else {
      fetchCategories(loadMorePath, searchTerm, false);
    }
  }, [searchTerm, location.pathname, isRefresh, userInfo?.profile_id]); // Add pathname to dependencies

  // useEffect(() => {
  //   setBreadCrumb([
  //     {
  //       name: `${show_proper_words(firstSegment)}`,
  //       path: `/${firstSegment}`,
  //       active: false,
  //     },
  //     {
  //       name: `Job Feeds`,
  //       path: "",
  //       active: true,
  //     },
  //   ]);
  // }, []);
  const handleDeleteMember = async (id) => {
    // ID as parameter lein
    setLoading(true);

    const response = await delete_live_job_feed_api(id);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      fetchCategories(load_more_path, searchTerm, false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
    setLoading(false);
    setDeleteLoading(false);
    setDeleteDialogOpen(false);
  };

  useEffect(() => {
    const storedBookmarks =
      JSON.parse(localStorage.getItem("bookmarkedJobs")) || {};
    setBookmarkedJobs(storedBookmarks);
  }, []);
  const handleBookmarkToggle = (jobId) => {
    let newBookmarkedState = false;
    setCategories((prev) => {
      return prev.map((job) => {
        if (job._id === jobId) {
          newBookmarkedState = !job.is_favourite;
          return { ...job, is_favourite: !job.is_favourite };
        }
        return job;
      });
    });

    let id = { job_id: jobId };

    favourite_live_job_api(id)
      .then((response) => {
        const successMessage = newBookmarkedState
          ? "Job added to favorites"
          : "Job removed from favorites";

        enqueueSnackbar(successMessage, { variant: "success" });
      })
      .catch((error) => {
        console.error("Error updating favorite job:", error);

        setBookmarkedJobs((prev) => {
          const revertedBookmarks = { ...prev, [jobId]: !newBookmarkedState };
          localStorage.setItem(
            "bookmarkedJobs",
            JSON.stringify(revertedBookmarks)
          );
          return revertedBookmarks;
        });

        enqueueSnackbar("Failed to update favorite status!", {
          variant: "error",
        });
      });
  };

  const handleUpdateSpecificJob = (updatedJob, setList = setCategories) => {
    if (updatedJob.deleted_job_id) {
      setList((prev) =>
        prev.filter((item) => item._id != updatedJob.deleted_job_id)
      );
      return;
    }
    setList((prev) =>
      prev.map((item) =>
        item._id == updatedJob._id ? { ...item, ...updatedJob } : item
      )
    );
  };

  useEffect(() => {
    // Register the function
    setUpdateJobOnNotification((data) => {
      handleUpdateSpecificJob(data, setCategories);
    });
    // Cleanup: reset function on unmount
    return () => {
      setUpdateJobOnNotification(() => {});
    };
  }, [categories]);

  // useEffect(() => {
  //   const scrollContainer = scrollRef.current;
  //   if (!scrollContainer) return;
  //   if (typeof window !== "undefined" && window.innerWidth <= 768) return;

  //   const interval = setInterval(() => {
  //     if (isHovered || isScrolling) return;

  //     const scrollTop = scrollContainer.scrollTop;
  //     const scrollHeight = scrollContainer.scrollHeight;
  //     const clientHeight = scrollContainer.clientHeight;

  //     const nearBottom = scrollTop + clientHeight >= scrollHeight - 5;

  //     if (nearBottom && categories.length > 0) {
  //       setIsScrolling(true);
  //       console.log("Reached bottom, scrolling to top");

  //       scrollContainer.scrollTo({ top: 0, behavior: "smooth" });

  //       setTimeout(() => {
  //         setIsScrolling(false);
  //       }, 1200);
  //     } else {
  //       scrollContainer.scrollTop += 1;
  //     }
  //   }, 30);

  //   return () => clearInterval(interval);
  // }, [isHovered, categories.length, isScrolling]);
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let scrollInterval = null;
    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(
      navigator.userAgent
    );

    const isIosMobile = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    const resetScrollToTop = () => {
      setIsScrolling(true);

      setTimeout(() => {
        // Use requestAnimationFrame for smoother transition
        requestAnimationFrame(() => {
          // Temporarily disable smooth scrolling for the reset
          scrollContainer.style.scrollBehavior = "smooth";
          scrollContainer.scrollTop = 0;

          // Trigger reflow
          void scrollContainer.offsetHeight;

          // Re-enable smooth scrolling
          setTimeout(() => {
            scrollContainer.style.scrollBehavior = "smooth";
            setIsScrolling(false);
          }, 2000);
        });
      }, 3000); // 3 second delay at the bottom before scrolling back to top
    };

    const startScroll = () => {
      scrollInterval = setInterval(
        () => {
          if (isHovered || isScrolling) return;

          const atBottom = isIosMobile
            ? Math.ceil(
                scrollContainer.scrollTop + scrollContainer.clientHeight
              ) >=
              scrollContainer.scrollHeight - 100
            : Math.ceil(
                scrollContainer.scrollTop + scrollContainer.clientHeight
              ) >=
              scrollContainer.scrollHeight - 5;

          if (atBottom && categories.length > 0) {
            if (isLoadMoreAvailable) {
              clearInterval(scrollInterval);
              resetScrollToTop(); // Wait 3 seconds then reset to top
            } else {
              resetScrollToTop(); // Wait 3 seconds then reset to top
            }
          } else {
            // Smoother scrolling for mobile devices
            if (isMobileDevice) {
              if (isIosMobile) {
                const iosAtBottom =
                  Math.ceil(
                    scrollContainer.scrollTop + scrollContainer.clientHeight
                  ) >=
                  scrollContainer.scrollHeight - 50;
                if (iosAtBottom && !isLoadMoreAvailable) {
                  scrollContainer.scrollTop += scrollContainer.clientHeight;
                  debounce(() => {
                    resetScrollToTop();
                  }, 10);
                } else {
                  scrollContainer.scrollTop += 50;
                }
              } else {
                scrollContainer.scrollBy({
                  top: 1,
                  behavior: "smooth",
                });
              }
            } else {
              if (isSafari) {
                scrollContainer.scrollTop += 3;
              } else {
                scrollContainer.scrollTop += 1;
              }
            }
          }
        },
        isIosMobile ? 30 : 20
      );
    };

    let lastTouchTime = 0;

    const stopScrollTemporarily = () => {
      const now = Date.now();
      if (now - lastTouchTime < 300) return; // debounce
      lastTouchTime = now;

      setIsScrolling(true);
      clearInterval(scrollInterval);
    };
    const startScrollOnTouchEnd = () => {
      clearInterval(scrollInterval);
      debounce(() => {
        setIsScrolling(false);
      }, 2000);
    };

    // Set initial smooth scrolling behavior
    scrollContainer.style.scrollBehavior = "smooth";
    startScroll();

    scrollContainer.addEventListener("touchstart", stopScrollTemporarily, {
      passive: true, // Changed to true for better performance
    });
    scrollContainer.addEventListener("touchend", startScrollOnTouchEnd, {
      passive: true, // Changed to true for better performance
    });

    return () => {
      clearInterval(scrollInterval);
      scrollContainer.removeEventListener("touchstart", stopScrollTemporarily);
      scrollContainer.removeEventListener("touchend", startScrollOnTouchEnd);
    };
  }, [isHovered, categories, isScrolling, loading]);

  // useEffect(() => {
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpenDetail = (job) => {
    navigate(`/${job.source?.slug}/job/${job.job_slug}`, {
      state: { job },
      topic: featuredJobs,
    });
  };
  const handleCandidates = (job) => {
    navigate(`/${job.source?.slug}/candidates/${job._id}`, {
      state: { data: job },
    });
  };
  const handleOpenEditJob = (job) => {
    if (
      (userInfo.membership_type !== "free" && !userInfo?.has_transactions) ||
      !userInfo.status
    ) {
      setOpenUpgradeModal(true);
      return;
    }
    // setEditMode(true);
    // setSelectedJob(job);
    // setOpen(true);
    navigate(`/${job.source.slug}/edit-job/${job.job_slug}`, {
      state: { job },
    });
  };

  // share post state and functions
  const handleOpenSharePost = (job) => {
    setSelectedJob(job);
    setOpenSharePost(true);
  };

  const handleOpen = () => {
    // Check if user has payment transaction
    if (
      (userInfo.membership_type !== "free" && !userInfo?.has_transactions) ||
      !userInfo.status
    ) {
      setOpenUpgradeModal(true);
      return;
    }
    setOpen(true);
    setEditMode(false);
  };

  const handleDelete = (row) => {
    setDeletingMemberId(row.job_slug);
    setDeleteDialogOpen(true);
  };

  const MENU_OPTIONS = (job) => {
    if (job?.created_by?._id === userInfo?.profile_id) {
      let optionsArray = [];

      if (
        (userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          userInfo?.company_access?.job?.update &&
          (userInfo?._id == job?.action_by?._id ||
            userInfo?.company_access?.job?.global_access))
      ) {
        optionsArray.push({
          label: "Edit",
          icon: "akar-icons:edit",
          handleClick(row) {
            handleOpenEditJob(row);
          },
        });
      }

      if (
        (userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          userInfo?.company_access?.job?.update &&
          (userInfo?._id == job?.action_by?._id ||
            userInfo?.company_access?.job?.global_access))
      ) {
        optionsArray.push({
          label: "Renew Job",
          icon: "mdi:refresh",
          handleClick: (row) => {
            handleRenewClick(row._id);
          },
          isRefresh: true,
          getDisabled: (row) => !getRenewalStatus(row), // Disable if can't renew
          getTooltip: (row) =>
            !getRenewalStatus(row)
              ? "You can only renew this job after 7 days of posting."
              : "",
        });
      }

      optionsArray.push({
        label: "Share Job",
        icon: "mdi:share-outline",
        handleClick: (row) => {
          handleOpenSharePost(row);
        },
      });

      if (
        (userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          userInfo?.company_access?.job?.delete &&
          (userInfo?._id == job?.action_by?._id ||
            userInfo?.company_access?.job?.global_access))
      ) {
        optionsArray.push({
          label: "Delete",
          icon: "ant-design:delete-twotone",
          handleClick: (row, index) => handleDelete(row), // Pass complete row instead of row._id
        });
      }

      return optionsArray;

      return [
        {
          label: "Edit",
          icon: "akar-icons:edit",
          handleClick(row) {
            handleOpenEditJob(row);
          },
        },
        {
          label: "Delete",
          icon: "ant-design:delete-twotone",
          handleClick: (row, index) => handleDelete(row),
        },

        {
          label: "Renew Job",
          icon: "mdi:refresh",
          handleClick: (row) => {
            handleRenewClick(row._id);
          },
          isRefresh: true,
          getDisabled: (row) => !getRenewalStatus(row), // Disable if can't renew
          getTooltip: (row) =>
            !getRenewalStatus(row)
              ? "You can only renew this job after 7 days of posting."
              : "",
        },
      ];
    } else {
      return [
        {
          label: "Share Job",
          icon: "mdi:share-outline",
          handleClick: (row) => {
            handleOpenSharePost(row);
          },
        },
        {
          label: "Report Job",
          icon: "material-symbols:report-outline",
          handleClick: (row, index) => handleNavigateReportJob(row),
          color: "error",
        },
      ];
    }
  };

  const handleNavigateReportJob = (job) => {
    // if (sourceSlug) {
    //   navigate(`/${sourceSlug}/report/job/${job._id}`);
    // } else {
    //   navigate(`/home/report/job/${job._id}`);
    // }
    handleReportPost(job, "job", handleFilterJob);
  };

  const handleFilterJob = (id) => {
    setCategories((prev) => prev.filter((item) => item._id !== id));
  };
  const getRenewalStatus = (row) => {
    if (!row?.next_renewal_date) return false;

    const renewalDate = new Date(row.next_renewal_date);
    const now = new Date();

    return renewalDate <= now; // true if arrived/passed, false otherwise
  };

  const OnclickOnMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  if (loading) {
    return <JobSkeleton width={isTablet ? "100%" : "300px"} />;
  }

  return (
    <>
      <CustomConfirmation
        open={openRenewConfirm}
        setOpen={setOpenRenewConfirm}
        title={"Are you sure you want to renew this job?"}
        headerHeading="Renew Job"
        handleAgree={() => {
          handleRenewJob(renewJobId);
        }}
      />

      <CustomModalLayout
        open={open}
        onClose={handleClose}
        title={editMode ? "Update Job" : "Post Job"}
        width="850px"
        componentToPass={
          <PostJobHeader
            refreshlist={fetchCategories}
            loadMorePath={load_more_path}
            searchTerm={searchTerm}
            loadingstate={loading}
            sourceSLug={sourceSlug}
            open={open}
            handleClose={handleClose}
            editMode={editMode}
            jobData={selectedJob}
          />
        }
      />

      {/* Upgrade Modal */}
      <UpgradeModal
        open={openUpgradeModal}
        handleClose={() => setOpenUpgradeModal(false)}
      />

      <div className="right-side-job-listing">
        {/* HEADER SECTION */}
        <div
          className="d-flex flex-wrap align-items-center justify-content-between margin-lef-right"
          style={{
            width: "100%",
            marginRight: isMobile ? "2px" : "",
            overflow: "hidden",
            marginLeft: "0px",
          }}
        >
          {/* PAGE TITLE */}
          <h4 className="groups-text mb-2 ps-2">
            {show_proper_words(pageTitle)}
          </h4>

          {/* CANDIDATE BUTTON */}
          {userInfo?.role === "candidate" && !userInfo?.isCompanyProfile && (
            <button
              className="btn-outlined-sm"
              onClick={handleNavigateAppliedJobs}
            >
              Applied Jobs
              <CheckCircleOutlineIcon />
            </button>
          )}

          {/* CLIENT OR COMPANY - POST JOB BUTTON */}
          {/* {((userInfo?.role === "client" && !userInfo?.isCompanyProfile) ||
            (userInfo?.isCompanyProfile &&
              userInfo?.company_access?.job?.add)) && (
            <button className="btn-outlined-sm" onClick={handleOpen}>
              Post Job
              <PostAddOutlinedIcon />
            </button>
          )} */}
        </div>

        {/* SCROLL WRAPPER */}
        <div
          className="right-side-jobs no-scrollbar"
          // ref={scrollRef}
          style={{
            // paddingInline: "12px",
            WebkitOverflowScrolling: "touch",
            paddingBottom: "50px",
            overflow: isMobile ? "clip" : "scroll",
          }}
        >
          <div className="community-left-sidebar px-md-3">
            {categories.length === 0 ? (
              <RecordNoImage title="No jobs Found" />
            ) : (
              <div
                className="row p-2"
                {...(!OnclickOnMobile && {
                  onMouseEnter: () => setIsHovered(true),
                  onMouseLeave: () => setIsHovered(false),
                })}
              >
                {categories.map((job) => (
                  <JobListCard
                    key={job._id}
                    job={job}
                    handlePageMove={handleOpenDetail}
                    isMobile={true}
                    MENU_OPTIONS={MENU_OPTIONS}
                    handleCandidates={handleCandidates}
                    handleBookmarkToggle={handleBookmarkToggle}
                    setJobsList={setCategories}
                  />
                ))}

                {/* LOAD MORE */}
                {totalPages >= pageNumber && (
                  <div className="col-12 text-center mt-3">
                    <span
                      ref={lastBookElementRef}
                      className="mt-3"
                      onClick={loadMoreData}
                      id="load-more-feed"
                    >
                      {isLoadingMore ? (
                        <CircularProgress color="primary" size="1.5rem" />
                      ) : pageNumber < totalPages ? (
                        "Load More"
                      ) : (
                        "No More Data Available"
                      )}
                    </span>
                  </div>
                )}
              </div>
            )}
            {/* DELETE JOB CONFIRMATION */}
            <CustomConfirmation
              open={deleteDialogOpen}
              setOpen={setDeleteDialogOpen}
              title="Are you sure you want to delete this job?"
              headerHeading="Delete Job"
              handleAgree={() => handleDeleteMember(deletingMemberId)}
            />
            {openSharePost && (
              <CustomModalLayout
                open={openSharePost}
                onClose={() => setOpenSharePost(false)}
                title="Share Job"
                width="550px"
                componentToPass={
                  <SharePostPopup
                    postData={{
                      ...selectedJob,
                      _id: selectedJob.job_slug,
                      description: selectedJob.job_title,
                    }}
                    type={"job"}
                  />
                }
              />
            )}
          </div>
        </div>

        {/* FOOTER */}
        <div className="m-3">
          <Footer isFullWidthFooter={false} />
        </div>
      </div>
    </>
  );
}
